<template>
  <div class="card company-card" :class="{ 'expanded-card': isExpanded }">
    <div class="card-content">
      <div class="media vertical-center">
        <figure class="media-left" v-if="suite.logo_path">
          <p class="image w-12 h-10 lg:w-16 lg:h-16">
            <img
              :src="fixHttpProtocol(suite.logo_path)"
              alt=""
              class="square-logo"
            />
          </p>
        </figure>
        <div class="media-content is-flex vertical-center">
          <div>
            <p class="title is-5">{{ suite.company.name }}</p>
            <p class="subtitle is-6" v-if="showParentCompany">
              {{ suite.name }}
            </p>
          </div>
        </div>
      </div>
      <div class="company-description">
        <span style="white-space: pre-wrap">
          <p v-text="suite.description" v-linkified></p>
          <p v-if="showParentCompany && suite.company.description" class="mt-4">
            <b>About {{ suite.company.name }}</b
            ><br />{{ suite.company.description }}
          </p>
        </span>
      </div>
    </div>
    <footer class="card-footer">
      <p class="card-footer-item">
        <router-link
          :to="{ name: 'ExhibitorSchedule', params: { suiteId: suite.id } }"
          exact
          class="button is-small is-primary is-inverted"
        >
          <span class="icon is-small">
            <i class="fas fa-arrow-right"></i>
          </span>
          <span>Book Appointment</span>
        </router-link>
      </p>
      <p
        class="card-footer-item"
        v-if="suite.description && suite.description.length > 0"
      >
        <button
          type="button"
          class="button is-small is-text"
          style="text-decoration:none"
          @click.prevent="isExpanded = !isExpanded"
        >
          {{ isExpanded ? 'Hide Info' : 'More Info' }}
        </button>
      </p>
    </footer>
  </div>
</template>

<script>
import { fixHttpProtocol } from '@/services/utils';

export default {
  props: ['suite'],

  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    fixHttpProtocol
  },
  computed: {
    showParentCompany() {
      return this.suite.name !== this.suite.company.name;
    }
  }
};
</script>

<style scoped>
.image.is-square img {
  object-fit: contain;
}

.vertical-center {
  align-items: center;
  align-content: center;
}

.max-96 {
  max-width: 96px;
}

.square-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/CompanyCard.vue